const storageKey = "dajia-active-session";
export function getWorkspaceKey() {
	return sessionStorage.getItem("dajia-view-workspace");
}
export function setWorkspaceKey(key: string | null) {
	if (key) {
		sessionStorage.setItem("dajia-view-workspace", key);
	} else {
		sessionStorage.removeItem("dajia-view-workspace");
	}
}
export function getSessionKey() {
	return sessionStorage.getItem(storageKey);
}
export function setSessionKey(key: string | null) {
	if (key) {
		sessionStorage.setItem(storageKey, key);
	} else {
		sessionStorage.removeItem(storageKey);
	}
}
export function sessionHeaders(): Record<string, string> {
	const key = getSessionKey();
	const scope = getWorkspaceKey();
	return {
		...(key ? { "X-Dajia-Session": key } : {}),
		...(scope ? { "X-Dajia-Workspace": scope } : {}),
	};
}
export function sessionUrl(path: string) {
	const key = getSessionKey();
	const params = new URLSearchParams();
	if (key) {
		params.set("session_key", key);
	}
	const scope = getWorkspaceKey();
	if (scope) {
		params.set("workspace_key", scope);
	}
	return params.size
		? `${path}${path.includes("?") ? "&" : "?"}${params}`
		: path;
}
